document.querySelectorAll('.Collection_reference_list_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
        loop: false,
        grabCursor: false,
        spaceBetween: 16,
        slidesPerGroup: 1,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        freeMode: !0,
        breakpoints: {
            0: {
                freeMode: !1,
                spaceBetween: 8,
                slidesPerView: "auto"
            },
            750: {
                spaceBetween: 16,
                slidesPerView: "auto"
            },
            990: {
                spaceBetween: 16,
                slidesPerView: "auto"
            },
            1200: {
            },
            1440: {
            }
        }
    })
  }
});

window.addEventListener("scroll", function () {
  const element = document.querySelector(".Reference_main_new");
  
  if (!element) return;

  const rect = element.getBoundingClientRect();

  if (rect.top <= 0) {
    document.body.classList.add("collection_fixed");
  } else {
    document.body.classList.remove("collection_fixed");
  }
});

(function() {
  var filterContainer = document.querySelector('.filter_main_new');
  if (!filterContainer) return;

  var filterToggles = [].slice.call(filterContainer.querySelectorAll('[data-filter-toggle]'));
  var emptyMessageTemplate = filterContainer.dataset.emptyMessage || 'There are currently <br>no {filter_name} options of {collection_name}';
  var grids = [].slice.call(document.querySelectorAll('.Collection_lists_inneritem_new'));

  function applyFilters() {
    var activeFilters = filterToggles
      .filter(function(t) { return t.checked; })
      .map(function(t) { return t.dataset.filterToggle; })
      .filter(Boolean);

    var hasFilters = activeFilters.length > 0;

    var filterLabels = filterToggles
      .filter(function(t) { return t.checked; })
      .map(function(t) { return t.parentElement.querySelector('span').textContent.trim(); });
    var filterName = filterLabels.join(', ');

    for (var g = 0; g < grids.length; g++) {
      var grid = grids[g];
      var gridProducts = [].slice.call(grid.querySelectorAll('.Collection_list_product_new[data-filter-types]'));
      var gridCustomBlocks = [].slice.call(grid.querySelectorAll('.Collection_list_custom_block_new'));
      var gridHeading = grid.querySelector('.Collection_list_heading_new');
      var emptyState = grid.querySelector('.Collection_filter_empty_state_new');
      var visibleCount = 0;

      for (var i = 0; i < gridProducts.length; i++) {
        var card = gridProducts[i];
        if (!hasFilters) {
          card.style.display = '';
          visibleCount++;
          continue;
        }
        var types = card.dataset.filterTypes || '';
        var show = true;
        for (var j = 0; j < activeFilters.length; j++) {
          if (types.indexOf('|' + activeFilters[j] + '|') === -1) { show = false; break; }
        }
        card.style.display = show ? '' : 'none';
        if (show) visibleCount++;
      }

      for (var k = 0; k < gridCustomBlocks.length; k++) {
        gridCustomBlocks[k].style.display = (hasFilters && visibleCount === 0) ? 'none' : '';
      }

      if (gridHeading) {
        gridHeading.style.display = (hasFilters && visibleCount === 0) ? 'none' : '';
      }

      if (emptyState) {
        if (hasFilters && visibleCount === 0) {
          var collectionName = grid.dataset.collectionName || '';
          var message = emptyState.querySelector('.Collection_filter_empty_message_new');
          
          if (message) {
            message.innerHTML = emptyMessageTemplate
              .replace('{filter_name}', filterName)
              .replace('{collection_name}', collectionName);
          }

          emptyState.style.display = '';
          emptyState.removeAttribute('hidden');
        } else {
          emptyState.style.display = 'none';
        }
      }
    }
  }

  filterContainer.addEventListener('change', function(event) {
    if (event.target && event.target.closest('[data-filter-toggle]')) {
      applyFilters();
    }
  });
})();